import StoreInstances, { getStoreFor } from 'Stores/StoreInstances'
import BaseStore from 'Stores/base_store/BaseStore'
import { action } from 'mobx'
import Bids from 'DataServices/Bids'

const STORE_TYPE = 'Bids'

export function getBidsStoreFor (param, opts = {}) {
  return getStoreFor(BidsStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

export class BidsStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  cancelBid (bidId) {
    return Bids.cancelBid(bidId)
      .then(bid => StoreInstances._propagateChanges(STORE_TYPE, [bid]))
  }

  @action
  rebid (bidId) {
    return Bids.rebid(bidId)
      .then(bid => StoreInstances._propagateChanges(STORE_TYPE, [bid]))
  }

  @action
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return Bids.getAll(payload)
  }
}
